import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/debt-avalanche-calculator',
  component: () => import('../../routes/DebtAvalancheCalculator.svelte'),
  card: {
    id: 'debt-avalanche-calculator',
    title: 'Debt Avalanche Calculator',
    description: 'Pay off debt using the avalanche method — highest interest rate first to minimize total interest paid. Mathematically optimal debt payoff strategy.',
    icon: 'account_balance_wallet',
    iconBgClass: 'bg-amber-50',
    iconTextClass: 'text-amber-600',
    href: '/debt-avalanche-calculator',
    category: 'Loans & Debt',
  },
  seo: {
    title: 'Debt Avalanche Calculator – Minimize Interest, Maximize Savings',
    description: 'Free debt avalanche calculator to pay off debt using the mathematically optimal strategy. Target highest interest rates first to save the most money on interest.',
  },
};

export default meta;
